export const defaultLang = process.env.REACT_APP_DEFAULT_LANGUAGE || "es";

export const secondLang = process.env.REACT_APP_SECOND_LANGUAGE || "en";

export const defaultLangName =
  process.env.REACT_APP_DEFAULT_LANGUAGE_NAME || "Spanish";

export const secondLangName =
  process.env.REACT_APP_SECOND_LANGUAGE_NAME || "English";

export const initialTranslationField = { [secondLang]: "", [defaultLang]: "" };
